import React from "react";
import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import { BASE_URL } from "config/api";
import SoftTypography from "components/SoftTypography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FaFilter } from "react-icons/fa";
import Grid from "@mui/material/Grid";
import SoftSelect from "components/SoftSelect";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from "@mui/icons-material/Close";
import SoftDatePicker from "components/SoftDatePicker";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import SoftButton from "components/SoftButton";
import Drawer from "@mui/material/Drawer";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Paper, Typography } from "@mui/material";
import {
    MdDashboardCustomize,
    MdOutlineHealthAndSafety,
    MdOutlineInsights,
    MdWarningAmber
} from "react-icons/md";

import {
    FaHospital,
    FaBaby,
    FaUsers,
    FaHeartbeat,
    FaDisease,
    FaBell,
    FaChartPie,
	FaPeopleArrows,
	FaUserFriends,
	Fadrop
} from "react-icons/fa";

import { HiOutlineUserGroup } from "react-icons/hi";
import { TbReportAnalytics, TbVaccine, TbAlertTriangle } from "react-icons/tb";
// import { GiPopulationGrowth } from "react-icons/gi";

const allTitles = [
	{ title: "Immunization Coverage" },
	{ title: "Avg Patient Waiting Time" },
	{ title: "Avg Patient Journey Time" },
	{ title: "Maternal Health Check-ups" },
	{ title: "TB Case Detection Rate" },
	{ title: "HIV Treatment Adherence" },
	{ title: "Malaria Prevention Coverage" },
	{ title: "Nutrition Program Reach" },
	{ title: "ABHA Creation Rate" },
	{ title: "Bed Occupancy Rate" },
	{ title: "Emergency Response Time" },
	{ title: "Readmission Rate" },
	{ title: "Staff-to-Patient Ratio" },
	{ title: "Staffing Gaps" },
];
const navigationItems = [
    {
        title: "Health Secretary Dashboard",
        icon: <MdDashboardCustomize size={18} />,
        path: "/#Dashboard",
    },

    {
        title: "Maharashtra Healthcare Dashboard",
        icon: <FaHospital size={18} />,
        path: "/#healthcare-infrastructure-dashboard",
    },

    {
        title: "Maternal Dashboard",
        icon: <MdOutlineHealthAndSafety size={18} />,
        path: "/#Maternal-Health-Dashboard",
    },

    {
        title: "Health Intelligence Dashboard",
        icon: <MdOutlineInsights size={18} />,
        path: "/#Health-Intelligence-Dashboard",
    },

    {
        title: "Mother & Child Care Dashboard",
        icon: <FaBaby size={18} />,
        path: "/#Mother-Child-Healthcare-Dashboard",
    },

    {
        title: "Integrated Health Dashboard",
        icon: <TbReportAnalytics size={18} />,
        path: "/#Integrated-Health-Dashboard",
    },

    {
        title: "RMNCH Dashboard",
        icon: <HiOutlineUserGroup size={18} />,
        path: "/#RMNCH-Dashboard",
    },

    {
        title: "Health System & Service Delivery Dashboard",
        icon: <FaUsers size={18} />,
        path: "/#Patient-Statistics-Dashboard",
    },

    {
        title: "Health Program Coverage Dashboard I",
        icon: <TbVaccine size={18} />,
        path: "/#Health-Program-Coverage-Map-Dashboard",
    },

    {
        title: "Health Program Coverage Dashboard II",
        icon: <TbVaccine size={18} />,
        path: "/#Health-Program-Coverage-Dashboard",
    },

    {
        title: "Non-Communicable Disease Dashboard",
        icon: <FaHeartbeat size={18} />,
        path: "/#NCD-Dashboard",
    },

    {
        title: "Communicable Disease Dashboard",
        icon: <FaDisease size={18} />,
        path: "/#Communicable-Disease-Dashboard",
    },

    {
        title: "Demographic Population Dashboard",
        icon: <FaUserFriends size={18} />,
        path: "/#Demographic-Population-Dashboard",
    },

    {
        title: "Alerts & Early Warning Indicators Dashboard",
        icon: <TbAlertTriangle size={18} />,
        path: "/#Alerts-Early-Warning-Indicators-Dashboard",
    },
	{
        title: "Anemia Dashboard",
        icon: <HiOutlineUserGroup size={18} />,
        path: "/#Anemia-Dashboard",
    },
	{
        title: "Maharashtra Programs Dashboard",
        icon: <HiOutlineUserGroup size={18} />,
        path: "/#Maharashtra-Programs-Dashboard",
    },
	{
        title: "Overview Dashboard",
        icon: <HiOutlineUserGroup size={18} />,
        path: "/#OverviewDashboard",
    },
	
];
const DateRangeLine = () => {
	const today = new Date();
	const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

	const formatDate = (date) =>
		date.toLocaleDateString("en-IN", {
			day: "2-digit",
			month: "short",
			year: "numeric",
		});

	return (
		<span className="text-sm text-slate-500 font-medium truncate px-3 py-1">
			State : <span className='fw-bold text-slate-700 pr-3'>Maharashtra</span>
			Date Range: <span className='fw-bold text-slate-700'>
				{formatDate(firstDay)} to {formatDate(today)}
			</span>
		</span>
	);
};
export const cardIconColor = "bg-[#428bab]"; //"bg-[#426eab]";

function Header({ onSearchChange, onMenuClick, selected, setSelected, dashboardName }) {
	const [token, setToken] = useState("");

	const [districts, setDistricts] = useState([
		{ value: "", label: "Select District" },
	]);
	const [tehsils, setTehsils] = useState([
		{ value: "", label: "Select Tehsil" },
	]);
	const [blocks, setBlocks] = useState([
		{ value: "", label: "Select Block" },
	]);
	const [gps, setGps] = useState([
		{ value: "", label: "Select GP" },
	]);
	const [facilityTypes, setFacilityTypes] = useState([
		{ value: "", label: "Select Facility Type" },
	]);

	const [facilities, setFacilities] = useState([
		{ value: "", label: "Select Facility" },
	]);
	const [selectedDistrict, setSelectedDistrict] = useState(null);
	const [selectedTehsil, setSelectedTehsil] = useState(null);
	const [selectedBlock, setSelectedBlock] = useState(null);
	const [selectedGp, setSelectedGp] = useState(null);


	const [selectedFacilityType, setSelectedFacilityType] = useState(null);
	const [selectedFacility, setSelectedFacility] = useState(null);

	const [showFilters, setShowFilters] = useState(false);
	const [showSettings, setShowSettings] = useState(false);
	const [openNav, setOpenNav] = useState(false);
	const [showSidebar, setShowSidebar] = useState(false); // <--- for left menu

	const [available, setAvailable] = useState(allTitles.slice(5));

	const onDragEnd = (result) => {
		if (!result.destination) return;
		const { source, destination } = result;

		if (source.droppableId === destination.droppableId) {
			if (source.droppableId === "available") {
				const updated = Array.from(available);
				const [moved] = updated.splice(source.index, 1);
				updated.splice(destination.index, 0, moved);
				setAvailable(updated);
			} else {
				const updated = Array.from(selected);
				const [moved] = updated.splice(source.index, 1);
				updated.splice(destination.index, 0, moved);
				setSelected(updated);
			}
		} else {
			if (source.droppableId === "available") {
				const avail = Array.from(available);
				const sel = Array.from(selected);
				const [moved] = avail.splice(source.index, 1);
				sel.splice(destination.index, 0, moved);
				setAvailable(avail);
				setSelected(sel);
			} else {
				const avail = Array.from(available);
				const sel = Array.from(selected);
				const [moved] = sel.splice(source.index, 1);
				avail.splice(destination.index, 0, moved);
				setAvailable(avail);
				setSelected(sel);
			}
		}
	};
	const fetchToken = async () => {
		const response = await fetch(`${BASE_URL}/token`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				client_key: "cccc",
				client_secret: "cccc",
			}),
		});

		const data = await response.json();
		console.log("Token API response:", data);

		const authToken = data.access_token || data.token;

		if (authToken) {
			setToken(authToken); // ✅ IMPORTANT
		}
	};

	const fetchDistricts = async (authToken) => {
		const res = await fetch(
			`${BASE_URL}/districts?state_lgd_code=27`,
			{
				headers: {
					Authorization: `Bearer ${authToken}`,
				},
			}
		);

		const data = await res.json();

		const options = data.districts.map((d) => ({
			value: d.district_lgd_code,
			label: d.district_name,
		}));

		setDistricts([{ value: "", label: "Select District" }, ...options]);
	};


	const fetchTehsils = async (districtCode) => {
		const res = await fetch(
			`${BASE_URL}/tehsils?district_lgd_code=${districtCode}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		const data = await res.json();

		const options = data.tehsils.map((t) => ({
			value: t.tehsil_lgd_code,
			label: t.tehsil_name,
		}));

		setTehsils([{ value: "", label: "Select Tehsil" }, ...options]);
		setBlocks([{ value: "", label: "Select Block" }]);
		setGps([{ value: "", label: "Select GP" }]);
	};


	const fetchBlocks = async (tehsilCode) => {
		const res = await fetch(
			`${BASE_URL}/blocks?tehsil_lgd_code=${tehsilCode}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		const data = await res.json();

		const options = data.blocks.map((b) => ({
			value: b.block_lgd_code,
			label: b.block_name,
		}));

		setBlocks([{ value: "", label: "Select Block" }, ...options]);
		setGps([{ value: "", label: "Select GP" }]);
	};

	const fetchGps = async (blockCode) => {
		const res = await fetch(
			`${BASE_URL}/gps?block_lgd_code=${blockCode}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		const data = await res.json();

		const options = data.gps.map((g) => ({
			value: g.gp_lgd_code,
			label: g.gp_name,
		}));

		setGps([{ value: "", label: "Select GP" }, ...options]);
	};
	const fetchFacilityTypes = async (authToken) => {
		try {
			const res = await fetch(`${BASE_URL}/facility-types`, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${authToken}`,
					"Content-Type": "application/json",
				},
			});

			const data = await res.json();

			// Defensive check
			const options = Array.isArray(data.facilityTypes)
				? data.facilityTypes.map((f) => ({
					value: f.facility_type_id,
					label: f.facility_type_name,
				}))
				: [];

			setFacilityTypes([
				{ value: "", label: "Select Facility Type" },
				...options,
			]);
		} catch (error) {
			console.error("Error fetching facility types:", error);
		}
	};

	const fetchFacilities = async (facilityType, blockCode) => {
		if (!facilityType || !blockCode) return;

		const res = await fetch(
			`${BASE_URL}/facilities?facility_type=${facilityType}&block_lgd_code=${blockCode}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		const data = await res.json();

		const options = data.facilities.map((f) => ({
			value: f.facility_id,
			label: f.facility_name,
		}));

		setFacilities([
			{ value: "", label: "Select Facility" },
			...options,
		]);
	};

	useEffect(() => {
		fetchToken();
	}, []);

	useEffect(() => {
		if (token) {
			fetchDistricts(token);
			fetchFacilityTypes(token); // 👈 add this
		}
	}, [token]);


	useEffect(() => {
		if (selectedDistrict?.value) {
			fetchTehsils(selectedDistrict.value);
		}
	}, [selectedDistrict]);

	useEffect(() => {
		if (selectedTehsil?.value) {
			fetchBlocks(selectedTehsil.value);
		}
	}, [selectedTehsil]);

	useEffect(() => {
		if (selectedBlock?.value) {
			fetchGps(selectedBlock.value);

			// reset facility
			setSelectedFacility(null);
			setFacilities([{ value: "", label: "Select Facility" }]);

			// refetch facilities if facility type already selected
			if (selectedFacilityType?.value) {
				fetchFacilities(selectedFacilityType.value, selectedBlock.value);
			}
		}
	}, [selectedBlock]);

	const handleDistrictChange = (selectedOption) => {
		setSelectedDistrict(selectedOption);

		// 🔁 RESET DEPENDENTS
		setSelectedTehsil(null);
		setSelectedBlock(null);
		setSelectedGp(null);
		setSelectedFacility(null);
		setTehsils([{ value: "", label: "Select Tehsil" }]);
		setBlocks([{ value: "", label: "Select Block" }]);
		setGps([{ value: "", label: "Select GP" }]);
		setFacilities([{ value: "", label: "Select Facility" }]);
		if (selectedOption?.value) {
			fetchTehsils(selectedOption.value);
		}
	};
	const handleTehsilChange = (selectedOption) => {
		setSelectedTehsil(selectedOption);

		// 🔁 RESET DEPENDENTS
		setSelectedBlock(null);
		setSelectedGp(null);
		setSelectedFacility(null);
		setBlocks([{ value: "", label: "Select Block" }]);
		setGps([{ value: "", label: "Select GP" }]);
		setFacilities([{ value: "", label: "Select Facility" }]);
		if (selectedOption?.value) {
			fetchBlocks(selectedOption.value);
		}
	};
	const handleBlockChange = (selectedOption) => {
		setSelectedBlock(selectedOption);
		setSelectedFacility(null);
		// 🔁 RESET GP
		setSelectedGp(null);
		setGps([{ value: "", label: "Select GP" }]);
		setFacilities([{ value: "", label: "Select Facility" }]);
		if (selectedOption?.value) {
			fetchGps(selectedOption.value);
		}
	};
	const handleFacilityTypeChange = (selectedOption) => {
		setSelectedFacilityType(selectedOption);

		// reset facility ONLY
		setSelectedFacility(null);
		setFacilities([{ value: "", label: "Select Facility" }]);

		// fetch facilities only if block exists
		if (selectedOption?.value && selectedBlock?.value) {
			fetchFacilities(selectedOption.value, selectedBlock.value);
		}
	};




	return (
		<>
			{/* === TOP HEADER === */}
			<SoftBox
				display="flex"
				alignItems="center"
				justifyContent="space-between"
				px={3}
				py={1}
				bgColor="white"
				boxShadow="sm"
				borderRadius="md"
				style={{ height: "7vh" }}
			>
				{/* Left Menu Button */}
				<IconButton onClick={() => setOpenNav(true)}>
					<MenuIcon />
				</IconButton>

				{/* Title */}
				<SoftTypography variant="h5" fontWeight="bold" color="dark">
					{dashboardName}
				</SoftTypography>

				{/* Filter */}
				<IconButton onClick={() => setShowFilters(!showFilters)}>
					<FaFilter />
				</IconButton>
			</SoftBox>

			{/* ============================= */}
			{/* === LEFT SIDEBAR ADDED HERE === */}
			{/* ============================= */}

			<Drawer
				anchor="left"
				open={openNav}
				onClose={() => setOpenNav(false)}
				PaperProps={{
					sx: {
						width: 340,
						padding: 0,
						backgroundColor: "#ffffff",
						boxShadow: "0 6px 30px rgba(0,0,0,0.15)",
						borderRight: "1px solid #e5e7eb",
					},
				}}
			>
				<div className="h-full flex flex-col">

					{/* Top Brand Header */}
					<div className="px-5 py-4 border-b border-gray-200">
						<h1 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
							<span className="w-2 h-2 bg-blue-600 rounded-full"></span>
							Dashboards
						</h1>
					</div>

					{/* Menu Items */}
					<div className="flex-1 overflow-y-auto px-2 py-4 space-y-1">

						{/* MAIN MENU */}
						<div>
							<p className="text-[11px] font-semibold uppercase text-gray-400 px-2 mb-2">
								Main Menu
							</p>

							{navigationItems.slice(0, 20).map((item) => (
								<div
									key={item.id}
									onClick={() => {
										window.location.href = item.path;
										setOpenNav(false);
									}}
									className="
									flex items-center gap-3 
									px-3 py-2.5
									rounded-lg text-[14px]
									text-gray-700 font-medium
									cursor-pointer
									hover:bg-gray-100 
									hover:text-blue-600
									transition-all
									text-wrap
									"
								>
									<span className="text-gray-500 text-lg">{item.icon}</span>
									{item.title}
								</div>
							))}
						</div>

						{/* Divider */}
						<div className="my-3 border-t border-gray-200"></div>

						{/* PREFERENCES */}
						{/* <div>
							<p className="text-[11px] font-semibold uppercase text-gray-400 px-2 mb-2">
								Preferences
							</p>

							{navigationItems.slice(5).map((item) => (
								<div
									key={item.id}
									onClick={() => {
										window.location.href = item.path;
										setOpenNav(false);
									}}
									className="
										flex items-center gap-3 
										px-3 py-2.5
										rounded-lg text-[15px]
										text-gray-700 font-medium
										cursor-pointer
										hover:bg-gray-100 
										hover:text-purple-600
										transition-all
										"
									>
									<span className="text-gray-500 text-lg">{item.icon}</span>
									{item.title}
								</div>
							))}
						</div> */}

					</div>
				</div>
			</Drawer>


			{/* -------------------------------- */}
			{/* REMAINING FILTER AREA (unchanged) */}
			{/* -------------------------------- */}

			{showFilters && (
				<SoftBox mt={2} px={3}>
					<Grid container spacing={2} alignItems="flex-end">
						<Grid item xs={12} md={2}>
							<SoftTypography variant="caption" fontWeight="bold" color="dark" mb={0.5}>
								District
							</SoftTypography>
							<SoftSelect
								options={districts}
								value={selectedDistrict}
								onChange={handleDistrictChange}
								placeholder="Select District"
							/>
						</Grid>

						<Grid item xs={12} md={2}>
							<SoftTypography variant="caption" fontWeight="bold" color="dark" mb={0.5}>
								Tehsil
							</SoftTypography>
							<SoftSelect
								options={tehsils}
								value={selectedTehsil}
								onChange={handleTehsilChange}
								placeholder="Select Tehsil"
								disabled={!selectedDistrict}
							/>
						</Grid>

						<Grid item xs={12} md={2}>
							<SoftTypography variant="caption" fontWeight="bold" color="dark" mb={0.5}>
								Block
							</SoftTypography>
							<SoftSelect
								options={blocks}
								value={selectedBlock}
								onChange={handleBlockChange}
								placeholder="Select Block"
								disabled={!selectedTehsil}
							/>
						</Grid>

						<Grid item xs={12} md={2}>
							<SoftTypography variant="caption" fontWeight="bold" color="dark" mb={0.5}>
								Facility Type
							</SoftTypography>
							<SoftSelect
								options={facilityTypes}
								value={selectedFacilityType}
								onChange={handleFacilityTypeChange}
								placeholder="Select Facility Type"
							/>
						</Grid>

						<Grid item xs={12} md={2}>
							<SoftTypography variant="caption" fontWeight="bold" color="dark" mb={0.5}>
								Facility
							</SoftTypography>
							<SoftSelect
								options={facilities}
								value={selectedFacility}
								onChange={setSelectedFacility}
								placeholder="Select Facility"
								disabled={!selectedFacilityType || !selectedBlock}
							/>
						</Grid>

						<Grid item xs={12} md={1}>
							<SoftTypography variant="caption" fontWeight="bold" color="dark" mb={0.5}>
								Month
							</SoftTypography>
							<SoftDatePicker
								input={{ placeholder: "Select Month" }}
								options={{
									dateFormat: "F Y",
									defaultDate: new Date(),
									plugins: [
										new monthSelectPlugin({
											shorthand: false,
											dateFormat: "F Y",
											altFormat: "F Y",
											theme: "light",
										}),
									],
								}}
							/>
						</Grid>

						<Grid item xs={12} md={1}>
							<SoftButton
								fullWidth
								variant="gradient"
								color="info"
								sx={{ height: "42px" }}
							>
								Apply
							</SoftButton>
						</Grid>
					</Grid>

				</SoftBox>
			)}

			{/* === KPI Drawer (unchanged) === */}
			{/** ... your full KPI drawer code stays untouched ... */}
			<div className="text-end">
				<DateRangeLine />
			</div>
		</>
	);
}

export default Header;
